module.exports = __webpack_public_path__ + "img/81.41c34de1.jpg";